<template></template>

<script setup>

import { ref } from 'vue';
import { useStore} from "vuex";

const store = ref(useStore())

window.onpopstate = () => {
    const params = Object.fromEntries(
        new URLSearchParams(window.location.search)
    )
    params['nextOrBack'] = true
    store.value.dispatch('applyFilters', params);
}
</script>
